import React, { useRef } from 'react';
import { PostImpressionSource } from 'apis/CompanyAPI/users/usersApi';
import usePostImpression from 'hooks/usePostImpression';

interface Props {
  contentId: string;
  source: PostImpressionSource;
  className?: string;
  children: React.ReactNode;
}

/** Wraps a post card in a list of posts and logs an impression once it has been on screen */
export default function PostImpression({ contentId, source, className, children }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  usePostImpression(contentId, ref, { type: 'list', source });

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
